<a
  class="button-link"
  [attr.role]="role"
  tabindex="0"
  [id]="id"
  [ngClass]="getClassObject()"
  [ngStyle]="{ width: fullWidth ? '100%' : 'auto' }"
  [routerLink]="url"
  (click)="removeFocus($event)"
  (keyup)="onKeyUpLink($event)"
  (keydown)="handleKeyDown($event)"
  [attr.aria-label]="ariaLabel || label"
  type="button"
>
  <div class="button-container" [ngStyle]="{ 'flex-direction': getTextAlign() }">
    @if(iconSvg){
    <img class="icon-svg" [src]="iconSvg" alt="Icon" />
    } @if(iconName){
    <span class="material-symbols-outlined">{{ iconName }}</span>
    } @if(label){
    {{ label }}
    }
  </div>
</a>
